import { ExpenseFormValues } from "@domains/reports/pages/forms/Forms";
import { CustomFieldFormValues } from "./graphql";

export const mergeExpenseFormValues = (
  prevValues: ExpenseFormValues,
  values: Partial<ExpenseFormValues>,
) => ({
  ...prevValues,
  ...values,
  customFieldEntries: mergeCustomFieldFormValues(
    prevValues.customFieldEntries,
    values.customFieldEntries,
  ),
});

export const mergeCustomFieldFormValues = (
  prevValues: CustomFieldFormValues,
  values?: CustomFieldFormValues,
) =>
  Object.entries(prevValues).reduce(
    (acc, [key, prevValue]) => ({
      ...acc,
      [key]: {
        ...prevValue,
        ...(values?.[key] ?? prevValue),
      },
    }),
    {},
  );
